module.exports = __webpack_public_path__ + "img/icon_tie@2x.5ae302cd.png";